import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, SimpleChanges, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CountryIconComponent } from '../country-icon/country-icon.component';

@Component({
  standalone: true,
  imports: [CommonModule, CountryIconComponent],
  selector: 'nrc-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LanguageComponent implements OnChanges {
  private static readonly LANGUAGE_NAMES: Record<string, string> = {
    ar: 'Arabic',
    az: 'Azeri',
    zh: 'Chinese',
    cs: 'Czech',
    nl: 'Dutch',
    en: 'English',
    fr: 'French',
    gd: 'Gaelic',
    de: 'German',
    it: 'Italian',
    ms: 'Malay',
    nb: 'Norwegian',
    pl: 'Polish',
    pt: 'Portuguese',
    ro: 'Romanian',
    ru: 'Russian',
    es: 'Spanish',
    sv: 'Swedish',
    uz: 'Uzbek',
    af: 'Afrikaans',
    sq: 'Albanian',
    am: 'Amharic',
    hy: 'Armenian',
    bn: 'Bengali',
    bs: 'Bosnian',
    bg: 'Bulgarian',
    ca: 'Catalan',
    hr: 'Croatian',
    da: 'Danish',
    fa: 'Dari',
    et: 'Estonian',
    tl: 'Filipino',
    fi: 'Finnish',
    ka: 'Georgian',
    el: 'Greek',
    gu: 'Gujarati',
    ht: 'Haitian Creole',
    ha: 'Hausa',
    he: 'Hebrew',
    hi: 'Hindi',
    hu: 'Hungarian',
    is: 'Icelandic',
    id: 'Indonesian',
    ga: 'Irish',
    ja: 'Japanese',
    kn: 'Kannada',
    kk: 'Kazakh',
    ko: 'Korean',
    lv: 'Latvian',
    lt: 'Lithuanian',
    mk: 'Macedonian',
    ml: 'Malayalam',
    mt: 'Maltese',
    mr: 'Marathi',
    mn: 'Mongolian',
    ps: 'Pashto',
    pa: 'Punjabi',
    sr: 'Serbian',
    si: 'Sinhala',
    sk: 'Slovak',
    sl: 'Slovenian',
    so: 'Somali',
    sw: 'Swahili',
    ta: 'Tamil',
    te: 'Telugu',
    th: 'Thai',
    tr: 'Turkish',
    uk: 'Ukrainian',
    ur: 'Urdu',
    vi: 'Vietnamese',
    cy: 'Welsh'
  };

  @Input({ required: true }) public code!: string;
  @Input() public countryCode?: string;

  @Input() public iconClassList?: string[];
  @Input() public textClassList?: string[];

  @Output() public clickEvent = new EventEmitter<void>();

  public name = '';

  /**
   *
   * @param changes
   */
  public ngOnChanges(changes: SimpleChanges) :void {
    if (changes['code'] && this.code) {
      this.name = LanguageComponent.LANGUAGE_NAMES[this.code.slice(0, 2)] ?? '';

      // If country code is not provided as input, extract it from the language code or update countryCode when code changes
      if (!changes['countryCode'] || !this.countryCode) {
        this.countryCode = this.code.slice(3, 5);
      }
    }
  }
}
